import { Outlet, createFileRoute } from "@tanstack/react-router"
import { automationQuery } from "@/lib/queries"

export const Route = createFileRoute("/w/$workspace/automations/$automationId")({
  loader: ({ context, params }) => context.queryClient.ensureQueryData(automationQuery(params.workspace, params.automationId)),
  component: () => <Outlet />,
})
